import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Copyright = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="126" viewBox="0 0 95 126" width="95" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="m85.04 17.6-2.56 1.26-2.56 1.25-.47-2.45-.64-3.3-1.25-6.57-5.2 3.53-3.3 2.26-1.9 1.28-.75-2.32-.89-2.74-1.9-5.8-6.94 18.32c10.55.1 18.74 4.1 24.75 11.68l9.6-19.33z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M81.42 33.99s-7.48 2.19-15.14-1.4c-7.66-3.61-9.61-10.29-9.61-10.29 10.55.12 18.74 4.1 24.75 11.68Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m72.35 11.32-3.3 2.26-1.9 1.27-.75-2.32-.9-2.73 4.86-2.92z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m85.04 17.6-2.57 1.26-2.56 1.25-.47-2.45-.64-3.31 5-1.48z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        d="M18.22 105.9v5.46a42.4 42.4 0 0 1-15-35.18 39 39 0 0 0 .65 5.1q-.01.07.04.14 0 .07.03.17l.01.14q.07.3.1.56l.04.15.33 1.34q.06.32.17.66.15.58.33 1.15l.18.6q.04.16.12.34.15.55.38 1.1.1.35.23.7.24.66.54 1.34.08.25.2.47a35 35 0 0 0 1.6 3.33l.09.17q.4.75.85 1.5.09.18.21.34.44.73.9 1.4.5.81 1.07 1.58a44 44 0 0 0 2.6 3.2q.45.5.92.99l.47.5q.35.36.73.7l.07.08q.48.5.97.91.1.12.2.2l.24.22.37.32q.15.17.37.32z"
        fill={shades.black}
      />
      <path
        className={strokeStyle}
        d="M18.23 105.9q-.22-.14-.37-.32l-.37-.32-.24-.22q-.1-.08-.2-.2-.5-.42-.97-.91l-.07-.08q-.39-.34-.73-.7l-.47-.5-.93-1a44 44 0 0 1-2.6-3.2q-.55-.76-1.07-1.56l-.89-1.4q-.12-.18-.21-.35-.45-.75-.85-1.5l-.1-.17q-.46-.84-.87-1.72a35 35 0 0 1-.92-2.08q-.3-.68-.54-1.34-.14-.35-.23-.7-.23-.55-.38-1.1-.08-.16-.12-.34l-.18-.6a41 41 0 0 1-.5-1.81l-.33-1.34-.03-.15-.1-.56-.02-.14-.03-.17-.04-.14q-.11-.48-.18-.98a39 39 0 0 1-.47-4.12q-.1 1.33-.1 2.73c0 13 5.86 24.65 15.1 32.45v-5.46Zm0 0"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M31.75 119.08c-5-1.72-9.58-4.36-13.53-7.71v-5.46l.04.04a34 34 0 0 0 1.63 1.3q.84.65 1.7 1.25l.08.05q.81.55 1.62 1.06.14.1.29.18l.1.05a19 19 0 0 0 1.76 1 22 22 0 0 0 1.85.96q.81.43 1.68.76l.34.15q.52.22 1.04.41.6.25 1.2.46.87.3 1.75.58c-2.46 0-2.97 3.48-1.54 4.96z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M80.74 49.5h-.01a42.5 42.5 0 0 0-35.1-18.53A42.56 42.56 0 0 0 3.23 76.2a39 39 0 0 0 .65 5.1q-.01.06.04.14 0 .07.03.17l.01.14.1.56.04.15.33 1.34q.06.32.17.66.15.57.33 1.15l.17.6.13.34q.15.55.38 1.1.1.34.23.7.24.66.54 1.34.08.25.2.47a35 35 0 0 0 1.6 3.33l.09.17q.4.75.85 1.5.09.18.21.34.44.73.9 1.4.5.8 1.07 1.57a44 44 0 0 0 2.6 3.2l.92 1 .47.5q.35.36.73.7l.07.08q.48.47.97.91.1.12.2.2l.24.22.37.32q.15.17.36.32h.01l.05.05a36 36 0 0 0 1.62 1.3h.01q.84.65 1.7 1.25l.08.04q.8.56 1.62 1.07l.29.18.09.05a19 19 0 0 0 1.76 1 22 22 0 0 0 1.85.96q.82.42 1.68.76l.34.15q.52.22 1.05.41.6.25 1.2.45.87.32 1.75.59l.17.05q.96.3 1.94.54.92.22 1.85.41.21.06.42.08.63.15 1.29.22h.04q.4.08.83.13.67.11 1.35.17h.07q.46.06.92.08.26.06.5.05h.13q.47.05.94.05l.17.01q.84.03 1.71.04A42.5 42.5 0 0 0 80.8 97.48a42.3 42.3 0 0 0 7.37-23.95 42.4 42.4 0 0 0-7.37-23.96v-.05zm-3.37 26.7a31.7 31.7 0 0 1-5.39 15.23 31.91 31.91 0 0 1-58.24-17.97A31.93 31.93 0 0 1 55.04 43a31.9 31.9 0 0 1 22.44 30.47q0 1.4-.12 2.74h-.01z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M55.04 43v5.48a32 32 0 0 0-18.15-.2v-5.47a31.4 31.4 0 0 1 18.15.2Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M36.89 42.8v5.47a31.9 31.9 0 0 0-23.04 27.92A31.9 31.9 0 0 1 36.87 42.8z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M77.5 73.45q-.01 1.4-.13 2.74a31.5 31.5 0 0 0-11.11-21.56v-5.46a31.8 31.8 0 0 1 11.22 24.28z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M66.28 49.18v5.46c-3.3-2.81-7.1-4.9-11.23-6.17v-5.48a32 32 0 0 1 11.23 6.18z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M57.26 69.24v5.48a11.7 11.7 0 0 0-12.76-7.35c1.13-.48 1.58-1.85 1.4-3.06l-.11-.48a2.7 2.7 0 0 0-.78-1.21 2 2 0 0 0-1.45-.51q.21-.07.42-.1.14-.05.28-.06.32-.07.66-.1.33-.05.7-.06.35-.04.7-.03c4.83 0 9.23 3.02 10.93 7.5z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M28.51 86.8v5.51a22.4 22.4 0 0 1-4.27-16.11 16 16 0 0 0 .32 1.87q.02.17.07.37l.2.78.29.97q.07.24.15.44.14.5.36.98.2.5.43.99.16.38.34.75.17.39.38.75.17.33.36.61.25.46.55.89l.82 1.16v.05Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M46.02 101.22a22.3 22.3 0 0 1-17.5-8.91v-5.5q.26.35.58.72.17.25.38.46a13 13 0 0 0 .8.91l.55.54q.27.28.55.54l.1.1.11.1q.35.28.7.6.36.31.78.6a21 21 0 0 0 2.04 1.33l1.1.61h.02q.55.3 1.14.55.53.24 1.1.45l.04.01q.68.26 1.4.47.51.17 1.07.29l.87.2q.34.08.69.12l.87.14q.3.06.6.07.3.05.6.06.35.06.7.05l1.07.03c-3.6 0-3.74 5.15-.33 5.46z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m57.26 77.67 9.92 3.8a22.4 22.4 0 0 1-22.6 14.21q-.32-.01-.62-.06-.29 0-.59-.07-.44-.06-.87-.14a3 3 0 0 1-.69-.13l-.87-.2q-.54-.11-1.07-.28-.7-.21-1.4-.47h-.04l-1.1-.46q-.57-.25-1.14-.55h-.01l-1.1-.61q-.55-.31-1.08-.66l-.97-.66-.77-.62q-.37-.3-.7-.6-.06-.03-.11-.1-.06-.04-.1-.1-.3-.23-.56-.53-.28-.25-.54-.54l-.34-.37a5 5 0 0 1-.47-.54q-.21-.23-.38-.46-.3-.35-.58-.72-.43-.58-.83-1.16-.3-.44-.54-.9l-.37-.6a6 6 0 0 1-.38-.75l-.34-.76a8 8 0 0 1-.42-.99 7 7 0 0 1-.37-.98l-.15-.43a16 16 0 0 1-.56-2.13l-.14-.66q-.12-.58-.18-1.2a22.35 22.35 0 0 1 22.12-25.06 22.4 22.4 0 0 1 20.82 14.3l-2.4.92-7.51 2.88a11.7 11.7 0 0 0-10.92-7.5q-.36-.01-.71.04l-.7.06q-.33.02-.66.1l-.28.05-.42.1a9 9 0 0 0-.94.28q-.46.15-.92.34a9 9 0 0 0-.92.46 11 11 0 0 0-1.17.73l-.37.28a9 9 0 0 0-1.53 1.4 7 7 0 0 0-.72.87q-.26.34-.48.7a11 11 0 0 0-1.16 2.38 11 11 0 0 0-.56 2.23q-.06.35-.07.7-.05.49-.05.98 0 1.4.32 2.74a11.71 11.71 0 0 0 22.29 1.46v-.04z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M44.51 67.36q-.49.06-.93.2h-.01a11.7 11.7 0 0 0-8.58 8.63 11 11 0 0 1-.28-3.72q.02-.35.08-.7l.12-.66q.17-.81.44-1.57.1-.31.23-.64.2-.46.43-.89.23-.45.5-.84.23-.37.48-.7.05-.1.12-.17.27-.36.6-.7.68-.8 1.53-1.4l.37-.3q.22-.13.4-.27a8 8 0 0 1 .82-.49l.87-.42a18 18 0 0 1 1.85-.61 2.2 2.2 0 0 1 1.63.68q.43.44.6 1.04.08.23.13.48c.17 1.21-.28 2.57-1.4 3.06h.02z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M67.18 81.46v5.47q-1.28 3.25-3.42 5.92l-.04.04a22.4 22.4 0 0 1-17.39 8.37l-.33-.01c-3.38-.32-3.27-5.46.33-5.46a22.4 22.4 0 0 0 20.84-14.3v-.03Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M88.1 78.93a42.4 42.4 0 0 1-7.38 23.95 42.5 42.5 0 0 1-48.96 16.22c-1.42-1.47-.92-4.96 1.54-4.96l.17.05q.97.3 1.94.54.92.22 1.85.41.21.06.42.08.63.15 1.3.22H39q.42.09.83.13.67.11 1.35.18h.08l.91.07q.26.06.51.05h.12a8 8 0 0 0 1.1.07l1.73.03a42.5 42.5 0 0 0 35.12-18.52c4.3-6.32 6.8-13.6 7.28-21.22q.08 1.35.09 2.72h-.01z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M67.18 65.45v5.47l-9.92 3.79v-5.47l7.52-2.88z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M8.53 19.7v10.1" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M13.58 24.75H3.48" strokeWidth={strokeWidth} />
    </svg>
  );
};
